import { withInstall } from '@fx-front-framework/utils/with-install'
import ActionButton from './src/action-button.vue'

export const FxActionButton = withInstall(ActionButton)
export default FxActionButton
